module.exports = __webpack_public_path__ + "img/banner-ebw-after.00874b13.png";